import styled from '@emotion/styled';
import Body1 from './Typography/Body/Body1';

export default styled(Body1)`
  && {
    text-align: center;
    margin: 0 16px 32px;
  }
`;
